import type { VendorDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getAll = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, VendorDto[]>({
      method: 'GET',
      url: '/api/app/vendor',
    },
    { apiName: this.apiName,...config });
}